import { render, staticRenderFns } from "./PassiveMonitorConfig.vue?vue&type=template&id=2032ed8a&scoped=true&"
import script from "./PassiveMonitorConfig.vue?vue&type=script&lang=js&"
export * from "./PassiveMonitorConfig.vue?vue&type=script&lang=js&"
import style0 from "./PassiveMonitorConfig.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./PassiveMonitorConfig.vue?vue&type=style&index=1&id=2032ed8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2032ed8a",
  null
  
)

export default component.exports